import React from 'react';
import DocPage from '../../components/DocPage/DocPage';

function About() {
  return (
    <DocPage eyebrow="About" title="About Orbix">
      <h2>Why we built Orbix</h2>
      <p className="doc-page__lead">
        We believe the systems people work within shape what they are able to achieve.
      </p>
      <p>
        When work carries real consequences, technology should help people do it properly. It should
        strengthen judgment, preserve what matters, and support a higher standard of work.
      </p>
      <p>That belief is why we built Orbix.</p>

      <h2>What Orbix does</h2>
      <p>
        Orbix is a platform for critical inspection operations. It connects imaging, inspection data,
        workflows, review, compliance, and AI-assisted quality oversight in one system.
      </p>
      <p>
        We are building a more reliable way to run inspection work. One that keeps evidence connected to every
        decision, makes quality easier to see and verify, and gives teams greater clarity and control across
        their operations.
      </p>

      <h2>Who we are</h2>
      <p>
        Orbix brings together experienced NDE professionals, software engineers, and AI specialists who
        believe critical work deserves better systems.
      </p>
      <p>
        We combine firsthand knowledge of the industry with deep technical expertise to build comprehensive
        solutions that support the people doing the work, strengthen quality, and address some of the
        industry's most persistent problems.
      </p>
      <p>
        Our aim is simple: to help raise the standard of critical inspection work by giving the people
        responsible for it better tools to do the work properly.
      </p>
    </DocPage>
  );
}

export default About;
